// export const inputClassNames =
//   "px-4 w-full bg-white-400 py-2 rounded-md shadow-sm border border-black";

export const inputClassNames =
  " px-4 py-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-100 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 dark:bg-[#F5F7F8]";

export const formSaveClassNames =
  "flex w-full justify-center rounded-md bg-indigo-600 px-3 py-3 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-[#183D3D]";

export const labelClassNames =
  "block text-sm font-medium leading-6 text-gray-900 dark:text-white";
